





























import { Component, Vue } from "vue-property-decorator";
import { sortTasks, sortScheduledTasks } from "@/data/models/TaskSortOrder";
import { SchedulingModule } from "@/store/modules/SchedulingModule";
import TaskItemComponent from "@/components/scheduling/TaskItem.vue";
import MenuIconWithSelectionListComponent from "@/components/common/StateButtonWithSelectionList.vue";
import TaskDetailsComponent from "@/components/scheduling/TaskDetails.vue";
import TaskListHeaderComponent from "./TaskListHeader.vue";
import { TaskState } from "@/data/models/TaskState";
import { Task } from "@/data/models/Task";

interface TaskListItem {
  task: Task;
  showHeaderForState?: TaskState;
  addMarginBeforeHeader?: boolean;
}

@Component({
  components: {
    "button-with-selection": MenuIconWithSelectionListComponent,
    "task-item": TaskItemComponent,
    "task-details": TaskDetailsComponent,
    "task-list-header": TaskListHeaderComponent,
  },
})
export default class TaskListComponent extends Vue {
  openTaskState = TaskState.OPEN;
  confirmedTasksState = TaskState.CONFIRMED;

  get highlightedTaskId() {
    return SchedulingModule.highlightedTaskId;
  }

  get focusedTask() {
    return SchedulingModule.focusedTask;
  }

  get unconfirmedTasks() {
    return sortTasks(
      SchedulingModule.openTasksSortOrder,
      SchedulingModule.unconfirmedTasksToDisplay,
      SchedulingModule.userSortOrderLookup
    );
  }

  get confirmedTasks() {
    return sortScheduledTasks(
      SchedulingModule.confirmedTasksSortOrder,
      SchedulingModule.confirmedTasksToDisplay,
      SchedulingModule.userSortOrderLookup
    );
  }
}
